<template>
  <div class="portrait-wrapper" :style="isTools ? { margin: '0 28px' } : {}">
    <div v-if="isTools" class="portrait-tool">
      <button class="btn" @click="openPortraitDialog('teacher')">
        授权肖像
      </button>
      <button class="btn" @click="openPortraitDialog('virtual')">
        虚拟形象
      </button>
      <button v-if="selectedPortrait.id === selectedId && isAllowDelete" class="btn" @click="deleteHead">
        删除人物
      </button>
    </div>
    <el-dialog
      v-for="dialogType in portraitDialogTypes"
      :key="dialogType"
      :visible="portraitDialogVisible[dialogType]"
      width="952px"
      :title="dialogType === 'virtual' ? '虚拟形象' : '授权肖像'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @update:visible="setDialogVisible(dialogType, $event)"
      @close="setDialogVisible(dialogType, false)"
    >
      <div class="portrait-head">
        <div v-if="dialogType === 'teacher'" class="search">
          <input type="text" v-model="keyword" :placeholder="searchPlaceholder" @keydown.enter="searchPortrait" />
          <span class="iconfont icon-sousuo" @click="searchPortrait"></span>
          <span v-if="keyword.length" class="cancel-search" @click="cancelSerach">×</span>
        </div>
        <div v-if="dialogType === 'virtual'" class="portrait-filters">
          <button
            v-for="gender in genderOptions"
            :key="gender.value"
            :class="['filter-btn', { on: virtualQuery.gender === gender.value }]"
            @click="changeVirtualFilter('gender', gender.value)"
          >
            <span class="radio"></span>
            {{ gender.label }}
          </button>
        </div>
      </div>
      <div v-if="!portraits.length" class="nothing">
        <img src="@/assets/images/styleImg/nothing.png" alt="" />
        <p class="tips">{{ emptyTips }}</p>
        <p class="txt">{{ emptyText }}</p>
      </div>
      <template v-else>
        <ul class="portraits" v-loading="isLoading">
          <li
            v-for="(item, index) of portraits"
            :key="index"
            :class="['item', { on: item.id === selectedPortrait.id }]"
            @click="selectedPortrait = item"
          >
            <span class="img"><img :src="`//bar.xkw.com${item.src}`" alt="" /></span>
            <span class="name">{{ getPortraitName(item, index) }}</span>
          </li>
        </ul>
        <el-pagination
          class="pagination"
          v-if="totalPage > 1"
          layout="total, prev, pager, next"
          :page-size="pageSize"
          background
          :total="currentPortraitMap.totalCount"
          @current-change="pageChange"
        >
        </el-pagination>
        <div class="tools">
          <button class="btn cancel-btn" @click="setDialogVisible(dialogType, false)">取消</button>
          <button
            :class="['btn', { 'disabled-btn': !selectedPortrait.id }]"
            :disabled="!selectedPortrait.id"
            @click="surePortrait"
          >
            确定
          </button>
        </div>
      </template>
      <div class="bottom" v-if="portraits.length">
        <p class="tips">{{ bottomTips }}</p>
        <p class="txt">{{ bottomText }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus";
import { getVirtualPortraits } from "@/assets/scripts/features";
export default {
  name: "AiFrontendUpload",
  props: {
    isAllowDelete: {
      type: Boolean,
      default: false,
    },
    teacherImgId: {
      type: Number,
      require: false,
    },
    selectedId: {
      type: Number,
      require: false,
    },
    portraitMap: {
      type: Object,
      default: () => ({
        list: [],
        totalCount: 0,
      }),
    },
    isTools: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // 显示头像弹窗
      portraitDialogVisible: {
        teacher: false,
        virtual: false,
      },
      portraitDialogTypes: ["teacher", "virtual"],
      // 头像列表
      portraits: [],
      // 选中的头像
      selectedPortrait: {},
      // 搜索词
      keyword: "",
      activePortraitType: "teacher",
      virtualPortraitMap: {
        list: [],
        totalCount: 0,
      },
      virtualQuery: {
        gender: "",
      },
      genderOptions: [
        { label: "全部", value: "" },
        { label: "男老师", value: 1 },
        { label: "女老师", value: 2 },
      ],
      isLoading: false,
      pageIndex: 1,
      pageSize: 14,
      totalPage: 0,
      openPortraitDialogHandler: null,
    };
  },
  computed: {
    currentPortraitMap() {
      return this.activePortraitType === "virtual" ? this.virtualPortraitMap : this.portraitMap;
    },
    searchPlaceholder() {
      return this.activePortraitType === "virtual" ? "虚拟形象仅支持按性别筛选" : "搜索您需要的老师姓名～";
    },
    emptyTips() {
      return this.activePortraitType === "virtual" ? "抱歉，暂时没有该虚拟形象" : "抱歉，暂时没有该老师的照片";
    },
    bottomTips() {
      return "没有您需要的老师照片？";
    },
    bottomText() {
      return "企业微信联系UED-张淼，发送您需要的老师照片，设计师抠图后会上传到此库中～";
    },
    emptyText() {
      return this.activePortraitType === "virtual"
        ? "请先在后台批量上传虚拟形象，并设置性别。"
        : "企业微信联系UED-张淼，发送您需要的老师照片，设计师抠图后会上传到此库中～";
    },
  },
  watch: {
    portraitMap: {
      handler(val) {
        if (this.activePortraitType !== "teacher") return;
        if (!val.list) return;
        this.setPortraitList(val);
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.openPortraitDialogHandler = type => {
      this.openPortraitDialog(type || "teacher");
    };
    eventBus.$on("openPortraitDialog", this.openPortraitDialogHandler);
    this.initVirtualPortraits();
  },
  beforeDestroy() {
    eventBus.$off("openPortraitDialog", this.openPortraitDialogHandler);
  },
  methods: {
    pageChange(pageIndex) {
      this.pageIndex = pageIndex;
      const list = this.currentPortraitMap.list.slice((pageIndex - 1) * this.pageSize, pageIndex * this.pageSize);
      this.portraits = list;
      // this.$emit("getPortraits", {
      //   teacherName: this.teacherName,
      //   pageIndex,
      // });
    },
    openPortraitDialog(type) {
      this.activePortraitType = type;
      this.portraitDialogVisible.teacher = false;
      this.portraitDialogVisible.virtual = false;
      this.keyword = "";
      this.pageIndex = 1;
      this.selectedPortrait = {};
      this.setPortraitList(this.currentPortraitMap);
      this.portraitDialogVisible[type] = true;
    },
    setDialogVisible(type, visible) {
      this.$set(this.portraitDialogVisible, type, visible);
    },
    // 确定选中头像
    surePortrait() {
      if (this.selectedPortrait.id) {
        this.$emit("selectPortrait", this.normalizePortrait(this.selectedPortrait));
      }
      this.setDialogVisible(this.activePortraitType, false);
    },
    deleteHead() {
      this.$emit("deletePortrait");
      this.selectedPortrait = {};
    },
    // 搜索头像
    searchPortrait() {
      this.pageIndex = 1;
      if (this.activePortraitType === "virtual") {
        this.getVirtualPortraits();
        return;
      }
      this.$emit("getPortraits", {
        teacherName: this.keyword,
        pageIndex: this.pageIndex,
      });
    },
    // 取消搜索
    cancelSerach() {
      this.keyword = "";
      this.pageIndex = 1;
      this.searchPortrait();
    },
    async initVirtualPortraits() {
      await this.getVirtualPortraits();
    },
    async getVirtualPortraits() {
      this.isLoading = true;
      const query = {
        gender: this.virtualQuery.gender,
        pageIndex: this.pageIndex,
        pageSize: 1000,
      };
      this.virtualPortraitMap = await getVirtualPortraits(query);
      if (this.activePortraitType === "virtual") {
        this.setPortraitList(this.virtualPortraitMap);
      }
      this.isLoading = false;
    },
    changeVirtualFilter(key, value) {
      this.virtualQuery[key] = this.virtualQuery[key] === value ? "" : value;
      this.pageIndex = 1;
      this.getVirtualPortraits();
    },
    setPortraitList(map) {
      if (!map || !map.list) return;
      const selectedEl = map.list.find(item => item.id === this.selectedId);
      this.selectedPortrait = selectedEl || {};
      this.portraits = map.list.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize);
      this.totalPage = Math.ceil(map.totalCount / this.pageSize);
    },
    getPortraitName(item, index) {
      if (item.teacherName) return item.teacherName;
      const currentIndex = index !== undefined ? index : this.portraits.findIndex(portrait => portrait.id === item.id);
      return `形象${(this.pageIndex - 1) * this.pageSize + currentIndex + 1}`;
    },
    normalizePortrait(item) {
      if (this.activePortraitType !== "virtual") return item;
      return {
        ...item,
        teacherName: this.getPortraitName(item),
        materialTypeId: 7,
        material_type_id: 7,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  min-width: 86px;
  margin: 0 6px;
  height: 34px;
  padding: 0 15px;
  line-height: 34px;
  font-size: 14px;
  background: #3f69f9;
  border-radius: 34px;
  cursor: pointer;
  color: #fff;
  text-align: center;
  line-height: 34px;
  border: none;
  &.cancel-btn {
    color: #3f69f9;
    line-height: 32px;
    border: 1px solid #3f69f9;
    background: #fff;
    &:hover {
      color: #fff;
      background: #3f69f9;
    }
  }
  &.disabled-btn {
    background: #ddd;
    color: #fff;
    cursor: not-allowed;
  }
  &:hover {
    opacity: 0.8;
  }
}
.portrait-wrapper {
  .upload-head_preview {
    position: relative;
    width: 91px;
    height: 91px;
    background: #dddddd;
    border-radius: 6px;
    margin-bottom: 56px;
    overflow: hidden;
    img {
      width: 100%;
    }
    .upload-head-close {
      display: inline-block;
      position: absolute;
      right: 0;
      top: 0;
      width: 14px;
      height: 14px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
      border-radius: 0px 6px 0px 6px;
      text-align: center;
      line-height: 14px;
      font-size: 12px;
      &:hover {
        background: #3f69f9;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        color: #fff;
        border-radius: 0px 6px 0px 6px;
      }
    }
  }
  .portrait-tool {
    display: flex;
    align-items: center;
    font-size: 14px;
    .btn {
    }
    .msg {
      color: #3f69f9;
    }
  }
  .portrait-head {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 36px;
    margin-bottom: 34px;
  }
  .search {
    position: relative;
    width: 360px;
    height: 36px;
    padding: 0 62px 0 20px;
    border-radius: 18px;
    border: 1px solid #ddd;
    overflow: hidden;
    background: #fff;
    input {
      display: block;
      width: 100%;
      height: 34px;
      line-height: 34px;
      border: none;
      outline: none;
      font-size: 14px;
      background: transparent;
      color: #333;
    }
    .iconfont {
    }
    .icon-sousuo {
      position: absolute;
      top: 0;
      right: 0;
      width: 44px;
      text-align: center;
      line-height: 34px;
      font-size: 20px;
      background: #ddd;
      color: #999;
      cursor: pointer;
    }
    .cancel-search {
      position: absolute;
      right: 50px;
      width: 24px;
      height: 34px;
      top: 0;
      text-align: center;
      line-height: 34px;
      font-size: 20px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    &:hover {
      border-color: #3f69f9;
      background: #f4f7ff;
      .icon-sousuo {
        background: #3f69f9;
        color: #fff;
      }
    }
  }
  .portrait-filters {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .filter-btn {
      display: flex;
      align-items: center;
      height: 22px;
      margin-left: 16px;
      padding: 0;
      border: none;
      background: transparent;
      color: #333;
      font-size: 14px;
      cursor: pointer;
      .radio {
        display: inline-block;
        width: 14px;
        height: 14px;
        margin-right: 6px;
        border: 1px solid #dcdfe6;
        border-radius: 50%;
        box-sizing: border-box;
      }
      &.on {
        color: #3f69f9;
        .radio {
          border: 4px solid #3f69f9;
        }
      }
    }
  }
  .portraits {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    gap: 30px;
    padding: 0;
    height: 290px;
    text-align: center;
    .item {
      padding: 0;
      width: 100px;
      height: 130px;
      margin: 0;
      border-radius: 8px;
      transition: all 0.2s;
      border: 1px solid transparent;
      overflow: hidden;
      background: transparent;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.06);
      }
      .img {
        display: block;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        background: url("./../assets/images/index/grid-bg_min.png") 0 0;
        background-size: auto 100px;
        img {
          display: block;
          height: 100px;
          transform: translateX(calc(-100% + 130px));
        }
      }
      .name {
        display: block;
        margin: 8px auto 0;
        color: #333;
        font-size: 14px;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &.on {
        border: 1px solid #3f69f9;
      }
    }
  }
  .nothing {
    height: 335px;
    padding: 100px 0;
    text-align: center;
    img {
      width: 173px;
    }
    .tips {
      height: 14px;
      font-size: 14px;
      color: #3f69f9;
      line-height: 14px;
      font-weight: 600;
      color: #3f69f9;
    }
    .txt {
      margin-top: 12px;
      font-size: 14px;
      color: #333333;
      line-height: 14px;
    }
  }
  .tools {
    position: absolute;
    bottom: 105px;
    right: 34px;
    .btn {
      min-width: 88px;
      height: 34px;
      border-radius: 18px;
    }
    .cancel-btn {
      color: #999;
      border-color: #bfbfbf;
    }
  }
  .pagination {
    position: absolute;
    left: 38px;
    bottom: 105px;
    margin-top: 0;
  }
  .bottom {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 16px;
    border-radius: 0 0 6px 6px;
    text-align: center;
    background: #f0f0f0;
    .tips {
      color: #3f69f9;
      line-height: 16px;
      font-size: 14px;
    }
    .txt {
      margin-top: 10px;
      line-height: 16px;
      font-size: 14px;
      color: #333;
    }
  }
}
::v-deep .el-dialog .el-dialog__body {
  position: relative;
  padding: 18px 36px 0;
  height: 534px;
  overflow: hidden;
}
::v-deep .el-dialog .el-dialog__header {
  padding: 24px 36px 17px;
}
::v-deep .el-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
::v-deep .el-dialog .el-dialog__headerbtn {
  top: 24px;
  right: 32px;
  font-size: 22px;
}
::v-deep .el-pagination.is-background {
  .btn-next,
  .btn-prev,
  .el-pager li {
    width: 34px;
    line-height: 32px;
    height: 34px;
    border-radius: 4px;
    border: 1px solid #ddd;
    background: #fff;
  }
  .el-pagination__total {
    height: 34px;
    line-height: 34px;
  }
  .el-pager li:not(.disabled).active {
    background-color: #3f69f9;
    border-color: #3f69f9;
    color: #fff;
  }
}
</style>
